// extracted by mini-css-extract-plugin
export default {"container":"Policy_container__QVCF0","title":"Policy_title__mWBbV","subText":"Policy_subText__-mnLm"};